import React from 'react';
import { useToast } from '../../context/ToastContext';
import styles from './Toast.module.css';

const ToastContainer: React.FC = () => {
  const { toasts, removeToast } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div className={styles.container}>
      {toasts.map((toast) => (
        <div key={toast.id} className={`${styles.toast} ${styles[toast.type]}`} role="alert">
          <span className={styles.message}>{toast.message}</span>
          <button className={styles.close} onClick={() => removeToast(toast.id)} aria-label="Dismiss">
            &times;
          </button>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
